/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedPartTimeJobListItemListDto } from '../models/PaginatedPartTimeJobListItemListDto';
import type { PartTimeJobDetailResultDto } from '../models/PartTimeJobDetailResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PartTimeJobsService {
  /**
   * 공고 가져오기 (login)
   * @returns PaginatedPartTimeJobListItemListDto
   * @throws ApiError
   */
  public static partTimeJobControllerPartTimeJobsWithLike({
    page,
    itemsPerPage,
    filterTitle,
    filterWorkDateType,
    filterWorkDate,
    filterWorkTimeType,
    filterWorkType,
    filterWorkForm,
    filterAddress,
  }: {
    page?: number;
    itemsPerPage?: number;
    filterTitle?: string;
    filterWorkDateType?: string;
    filterWorkDate?: string;
    filterWorkTimeType?: string;
    filterWorkType?: string;
    filterWorkForm?: string;
    filterAddress?: string;
  }): CancelablePromise<PaginatedPartTimeJobListItemListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-time-jobs',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
        'filter[title]': filterTitle,
        'filter[workDateType]': filterWorkDateType,
        'filter[workDate]': filterWorkDate,
        'filter[workTimeType]': filterWorkTimeType,
        'filter[workType]': filterWorkType,
        'filter[workForm]': filterWorkForm,
        'filter[address]': filterAddress,
      },
    });
  }

  /**
   * 공고 가져오기 (public)
   * @returns PaginatedPartTimeJobListItemListDto
   * @throws ApiError
   */
  public static partTimeJobControllerPublicPartTimeJobs({
    page,
    itemsPerPage,
    filterTitle,
    filterWorkDateType,
    filterWorkDate,
    filterWorkTimeType,
    filterWorkType,
    filterWorkForm,
    filterAddress,
  }: {
    page?: number;
    itemsPerPage?: number;
    filterTitle?: string;
    filterWorkDateType?: string;
    filterWorkDate?: string;
    filterWorkTimeType?: string;
    filterWorkType?: string;
    filterWorkForm?: string;
    filterAddress?: string;
  }): CancelablePromise<PaginatedPartTimeJobListItemListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-time-jobs/public',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
        'filter[title]': filterTitle,
        'filter[workDateType]': filterWorkDateType,
        'filter[workDate]': filterWorkDate,
        'filter[workTimeType]': filterWorkTimeType,
        'filter[workType]': filterWorkType,
        'filter[workForm]': filterWorkForm,
        'filter[address]': filterAddress,
      },
    });
  }

  /**
   * 공고 상세 가져오기 (public)
   * @returns PartTimeJobDetailResultDto
   * @throws ApiError
   */
  public static partTimeJobControllerPublicPartTimeJob({
    id,
  }: {
    id: number;
  }): CancelablePromise<PartTimeJobDetailResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-time-jobs/public/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * 내가 찜한 공고 가져오기
   * @returns PaginatedPartTimeJobListItemListDto
   * @throws ApiError
   */
  public static partTimeJobControllerLikedPartTimeJobs({
    page,
    itemsPerPage,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedPartTimeJobListItemListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-time-jobs/liked',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 공고 상세 가져오기
   * @returns PartTimeJobDetailResultDto
   * @throws ApiError
   */
  public static partTimeJobControllerPartTimeJob({
    id,
  }: {
    id: number;
  }): CancelablePromise<PartTimeJobDetailResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/part-time-jobs/{id}',
      path: {
        id: id,
      },
    });
  }
}
